import { h, render, hydrate } from 'preact';
import './styles/main.scss';
import { ProductRecommendationSection } from './pages/ProductRecommendationSection';
// Mount a ProductRecommendationSection into every [data-recommendation-app] element,
// driven by its dataset attributes. Supports multiple carousels on one page
// (e.g. "related-items" + "bestsellers").
document.querySelectorAll('[data-recommendation-app]').forEach(el => {
    // Only identity + UI concerns are read here. All provider-payload options
    // (widget ID, page type, Boost-specific fields) are the component's concern
    // — it reads them off `mountElement` via its platform-specific helper.
    const props = {
        seedProductId: el.dataset.seedProductId,
        recsType: el.dataset.recommendationType,
        title: el.dataset.title,
        mountElement: el,
    };
    if (el.hasChildNodes()) {
        hydrate(h(ProductRecommendationSection, Object.assign({}, props)), el);
    }
    else {
        render(h(ProductRecommendationSection, Object.assign({}, props)), el);
    }
});
// `window.mrRecommendations.refresh(selector, recsConfigOverride?)` is installed
// as a side effect of importing `useRecsProvider` (transitively, via
// `ProductRecommendationSection` above). Theme code can call it to re-trigger
// a fetch without remounting — see `src/search/useSearchProvider.ts` for the
// full API contract.
